export default __webpack_public_path__ + "static/media/dyeing2.094aa43b.png";